import { requestHelpers } from '../../../../../helpers';
import * as setters from './setters';
import { getPicture, getPictureError } from './picture';
import { getCustomUrl } from './url';
import { getUserPermissions } from './permissions';

export const actions = {
    SET_PROFILE: 'SET_PROFILE',
    GET_PROFILE: 'GET_PROFILE',
    GET_PROFILE_ERROR: 'GET_PROFILE_ERROR',
    DESTROY_PROFILE: 'DESTROY_PROFILE',
};

export const getProfile = ( personId, guestMode ) => {
    return dispatch => {
        dispatch( {
            type: actions.GET_PROFILE,
            isFetching: true,
            isError: false,
        } );
        requestHelpers
            .authenticatedGetRequest( `/profiles/${ personId }` )
            .then( ( response ) => {
                const personId = response.data.id;
                const profile = response.data;
                dispatch( setters.setHeadline ( profile ) );
                dispatch( setters.setName ( profile ) );
                dispatch( setters.setLocations( profile) );
                dispatch( setters.setIndustries ( profile ) );
                dispatch( setters.setVisibility( profile ) );
                dispatch( setters.setSummary( profile ) );
                dispatch( setters.setExperience( profile ) );
                dispatch( setters.setEndorsements( profile ) );
                dispatch( setters.setEducation( profile ) );
                dispatch( setters.setCertificates( profile ) );
                dispatch( setters.setPress( profile) );
                dispatch( setters.setAwards( profile ) );
                dispatch( setters.setPublications( profile ) );
                dispatch( setters.setForms() );
                dispatch( setters.setMarkets( profile ) );
                dispatch( setters.setExpertise( profile ) );
                dispatch( setters.setSectors( profile ) );
                dispatch( setters.setGuestMode( guestMode ));
                dispatch( setters.setInvestments( profile ) );
                dispatch( setters.setRating( profile ) );
                return personId;
            })
            .then ( ( personId ) => {
                const  picturePath = new Request (`https://s3.intouchnetworks.com/getImage.php?id=${ personId }`);

                dispatch ( getPicture( personId ) );

                fetch( picturePath )
                    .then( ( response ) => response.text() )
                    .then( ( url ) => {
                        dispatch( setters.setPictureUI() );
                        return dispatch( setters.setPicture( personId, url ) );
                    })
                    .catch( error => dispatch( getPictureError(error) ) );
                return personId;
            })
            .then( personId => {
                dispatch( getCustomUrl( personId ) )
            })
            .then( () => dispatch( setters.getCountries() ) )
            .then( () => dispatch( getUserPermissions ( personId ) ) )
            .then( () => dispatch ( setters.getInvestmentsList() ) )
            .then( () => dispatch( {
                type: actions.SET_PROFILE,
                isFetching: false,
                isError: false,
                hideToggle: guestMode,
                personId: parseInt(personId, 10),
            } ) )
            .catch( ( error ) => {
                console.log('ERROR:', error );
                return dispatch({
                    type: actions.GET_PROFILE_ERROR,
                    error,
                    isFetching: false,
                    isError: true,
                });
        });
    }
};

export const destroyProfile = () => {
    return (dispatch) => {
        dispatch({
            type: actions.DESTROY_PROFILE,
            isFetching: false,
            isError: false,
        })
    }
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/profile.js